<template>
    <section v-if="products.length" class="related-products">
        <slot></slot>
        <slick :options="slickOptions">
            <listing-product-item v-for="product in products" :key="product.id" :product="product"  :translations="translations"></listing-product-item>
        </slick>
    </section>
</template>

<script>
/*
* [name] Vue component
* ---
* [description here]
* Example usage:
*
* [example usage here]
*/

import axios from 'axios';
import Slick from 'vue-slick';

import ListingProductItem from './listing-product-item.vue';

export default {
    components: {
        Slick,
        ListingProductItem
    },

    props: [
        'productId',
        'translations'
    ],

    data() {
        return {
            isLoading: false,
            products: [],
            slickOptions: {
                slidesToShow: 4, 
                responsive: [{ 
                    breakpoint: 768, 
                    settings: { 
                        slidesToShow: 2, 
                        infinite: false, 
                        arrows: false, 
                        dots: true 
                    } 
                }]
            }
        }
    },

    created() {
        this.isLoading = true;

        axios.get(`/recommendations/products.json?product_id=${ this.productId }`).then(response => {
            console.log('/recommendations/products.json', response.data);
            this.products = response.data.products;

        }).catch(error => {
            console.log(error);

        }).finally(() => {
            this.isLoading = false;
        });
    }
}
</script>